const LOCK_PREFIX = 'beliruma-agent-listing-draft-lock:';
const LEASE_MS = 30000;
const HEARTBEAT_MS = 10000;

let releaseWebLock = null;
let fallbackTimer = null;
let fallbackKey = null;
let channel = null;
let heldUserUuid = null;
const tabId = `${Date.now()}-${Math.random().toString(36).slice(2)}`;

function readLease(key) {
  try {
    return JSON.parse(window.localStorage.getItem(key));
  } catch (_) {
    return null;
  }
}

function writeLease(key) {
  window.localStorage.setItem(key, JSON.stringify({ tabId, updatedAt: Date.now() }));
}

function acquireFallback(userUuid) {
  try {
    const key = `${LOCK_PREFIX}${userUuid}`;
    const lease = readLease(key);
    if (lease && lease.tabId !== tabId && Date.now() - lease.updatedAt < LEASE_MS) return false;

    writeLease(key);
    const confirmed = readLease(key);
    if (!confirmed || confirmed.tabId !== tabId) return false;

    fallbackKey = key;
    fallbackTimer = window.setInterval(() => writeLease(key), HEARTBEAT_MS);
    if (typeof window.BroadcastChannel === 'function') {
      channel = new window.BroadcastChannel(key);
      channel.postMessage({ type: 'acquired', tabId });
    }
    return true;
  } catch (_) {
    return true;
  }
}

function acquireRememberedFallback(userUuid) {
  const acquired = acquireFallback(userUuid);
  if (acquired) heldUserUuid = userUuid;
  return acquired;
}

export async function acquireListingDraftLock(userUuid) {
  if (typeof window === 'undefined' || !userUuid) return false;
  if (heldUserUuid === userUuid) return true;
  const lockName = `${LOCK_PREFIX}${userUuid}`;

  if (navigator.locks && navigator.locks.request) {
    return new Promise((resolve) => {
      navigator.locks
        .request(lockName, { ifAvailable: true }, async (lock) => {
          if (!lock) {
            resolve(false);
            return;
          }
          heldUserUuid = userUuid;
          resolve(true);
          await new Promise((release) => {
            releaseWebLock = release;
          });
        })
        .catch(() => resolve(acquireRememberedFallback(userUuid)));
    });
  }

  return acquireRememberedFallback(userUuid);
}

export function releaseListingDraftLock() {
  if (releaseWebLock) releaseWebLock();
  releaseWebLock = null;

  if (fallbackTimer) window.clearInterval(fallbackTimer);
  fallbackTimer = null;
  if (fallbackKey) {
    const lease = readLease(fallbackKey);
    if (lease && lease.tabId === tabId) {
      try {
        window.localStorage.removeItem(fallbackKey);
      } catch (_) {
        fallbackKey = null;
      }
    }
  }
  if (channel) {
    channel.postMessage({ type: 'released', tabId });
    channel.close();
  }
  channel = null;
  fallbackKey = null;
  heldUserUuid = null;
}
